import DataResource from '../../../common/v4/DataResource'
import Panel from '../../../common/layout/Panel'
import Tabs from '../../../common/Tabs'
import { aiTabs } from '../shared/aiTabs';

const AiTools = (props) => {
    const data = {
        url: '/admin/ai/tools',
        data: {
            data: [],
            metadata: []
        },
        onclick: 'link',
        link: '/ai/tools/{id}',
        userfilter:[
            {
                source: 'ATRDIDNUMBER',
                label: 'Number',
                type: 'text',
                default: ''
            },
        ],
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Name',
                source: 'name',
                type: 'text',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'Description',
                source: 'description',
                type: 'text',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'Function',
                source: 'function_id',
                type: 'select',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'Enabled',
                source: 'status',
                type: 'boolean',
                editable: true,
                default: true,
                values: {
                    1: 'YES',
                    0: 'NO'
                },
                classnames: {
                    1: 'label label-info',
                    0: 'label label-danger'
                }
            },
            {
                label: 'Created At',
                source: 'created_at',
                type: 'datetime'
            },
            {
                label: 'Updated At',
                source: 'updated_at',
                type: 'datetime'
            },
            {
                label: 'Delete',
                type: 'delete',
            }
        ]
    }
    
    return (
        <Panel title="AI Tools">
            <>            
                <Tabs tabs={aiTabs} />
                <DataResource
                    addButtonText="Create New AI Tool"
                    addButtonType="link"
                    addButtonLink="/ai/tools/create"
                    data={data}
                    {...props}
                />
            </>
        </Panel>
    );
}

export default AiTools;